import { FC, ReactElement, useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import TopBar from '../connected/TopBar';
import CustomReportToolBar from '../connected/CustomReportToolBar';
import SideBar from '../connected/SideBar';
import Footer from '../connected/Footer';
import { TOPBAR_HEIGHT } from '../component/compound/TopBar';
import { RootRef } from '@material-ui/core';

type Props = {
  children: ReactElement<any>;
  className?: string;
};

const CustomReportLayout: FC<Props> = ({ children, className }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  });

  const mainStyle = {
    paddingTop: height,
  };

  return (
    <Root className={className}>
      <TopBar />
      <SideBar />
      <Content style={mainStyle}>
        <RootRef rootRef={ref}>
          <Toolbar />
        </RootRef>
        {children}
        <Footer />
      </Content>
    </Root>
  );
};

const Root = styled('div')({
  height: '100%',
  paddingLeft: 302,
});

const Content = styled.main((props) => ({
  height: '100%',
  paddingTop: props.style ? props.style.paddingTop : undefined,
}));

const Toolbar = styled(CustomReportToolBar)({
  position: 'fixed',
  top: TOPBAR_HEIGHT,
  zIndex: 1,
});

export default CustomReportLayout;
